import { gql } from 'graphql-request'
import { productPrice } from '../fragments/productFragment'

export const menuCompleteDetailQuery = gql`
    query companyBranches($branchId: ID!) {
        wareCategories(
            companyBranch: $branchId
            wareCategoryType: MAIN
            enabled: true
            isAvailable: true
            orderOriginCategory: DOVEZE
            withoutPromoTags: [HIDDEN_FROM_STANDARD]
        ) {
            id
            nameLabel
            recipes(enabled: true, isAvailable: true) {
                id
                nameLabel
                image
                imagePreview: image(width: 200, height: 200)
                descriptionLabel
                soldOut
                allergens {
                    category
                }
                price {
                    ...productPrice
                }
                recipeTags {
                    id
                }
            }
        }
    }
    ${productPrice}
`
